import styled, { css } from 'styled-components';
import FormWrapper from '../../components/FormWrapper';
import TableComponent from '../../components/Table';
import ButtonComponent from '../../components/Button';

export const Container = styled.section`
  margin-bottom: 30px;
  grid-column: 2/3;
  @media (max-width: 768px) {
    grid-column: 1;
  }
  @media (min-width: 769px) and (max-width: 1600px) {
    grid-column: 1/4;
  }
`;

export const IncludeDependentsContainer = styled.div`
  grid-column: 2/3;
  @media (max-width: 768px) {
    grid-column: 1;
  }

  /* @media (min-width: 769px) {
    overflow-y: hidden;
  } */

  @media (min-width: 769px) and (max-width: 2500px) {
    grid-column: 1/4;
    padding: 0 0px;
  }

  form {
    display: flex;
    flex-wrap: wrap;
    > button {
      text-transform: uppercase;

      &.marginRight {
        margin-right: auto;
      }
      &.marginLeft {
        margin-left: auto;
      }
    }
    &.request-copy-card,
    &.change-contract {
      margin-bottom: 30px;
    }
    &.form-termination-beneficiary {
      > button {
        margin: 0;
        &:nth-of-type(1) {
          margin-right: auto;
        }
      }
    }
    &.form-change-product-details {
      margin-bottom: 24px;
      & + form {
        margin-bottom: 30px;
      }
    }
    &.form-change-request-datasheet {
      margin-bottom: 24px;
    }
    &.actions-include-dependent {
      margin: 24px 0 30px;
    }
    &.depentent-include {
      /* .select-city button:first-child,
      .select-state button:first-child,
      .select-genre button:first-child,
      .select-uf button:first-child,
      .select-marital-status button:first-child {
        display: none;
      } */

      @media (max-width: 768px) {
        > div {
          &:nth-child(5),
          &:nth-child(6) {
            width: auto;
            flex: 1 1;
          }
          &:nth-child(14),
          &:nth-child(15) {
            width: auto;
            min-width: 45%;
            flex: 1 1;
          }
          &:nth-child(16),
          &:nth-child(17) {
            width: auto;
            min-width: 45%;
            flex: 1 1;
          }
        }
      }
    }
    &.beneficiaries-home {
      @media (max-width: 768px) {
        > div {
          &:nth-child(4),
          &:nth-child(5) {
            width: auto;
            flex: 1 1;
          }
        }
      }
    }
  }

  div.table-wrapper-beneficiaries {
    margin-top: 24px;
    div.p-datatable-scrollable-view.p-datatable-frozen-view {
      div.p-datatable-scrollable-header {
        background: transparent;
      }
      table {
        tbody {
          tr.p-row-expanded {
            opacity: 0;
            pointer-events: none;
          }
          tr.p-highlight.p-selectable-row {
            border-left-width: 2px !important;
          }
        }
      }
    }
    div.p-datatable-scrollable-view.p-datatable-unfrozen-view {
      div.p-datatable-scrollable-header {
        background: transparent;
      }
      table {
        tbody {
          tr.p-highlight.p-selectable-row {
            border-left: none !important;
          }
        }
      }
    }
    table {
      th {
        /* word-break: break-word; */
        height: 50px;
        span {
          display: flex;
          height: 1rem;
          align-items: center;
        }
        &.frozen {
          border-radius: 10px 0 0 0 !important;
        }
        &.no-rounded {
          border-radius: 0 0 0 0 !important;
        }
      }
      tr.p-highlight {
        td.centered {
          > label {
            > img {
              ${(props) =>
                props.theme.title === 'dark' &&
                css`
                  filter: grayscale(1) brightness(1.4);
                `}
            }
          }
        }
      }
      td {
        white-space: nowrap;
        &:not(.centered) {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.centered {
          overflow: visible !important;

          > label {
            position: relative;
            > img {
              display: inline;
              transform: translateY(1px);

              filter: grayscale(1) brightness(0.4);

              transition: 300ms;
            }
            &::before {
              content: attr(data-hover);
              position: absolute;
              background: ${(props) => props.theme.colors.palet.institutional4};
              padding: 4px 10px;
              font-family: 'Unimed-Sans-Bold';
              color: ${(props) => props.theme.colors.palet.institutional2};
              top: calc(-100% - 16px);
              right: 50%;
              border-radius: 5px 5px 0 5px;
              font-size: 0.65rem;

              opacity: 0;
              visibility: hidden;
              transform: translateY(10px);
              transition: 300ms;
            }
            &::after {
              content: '';
              position: absolute;
              top: -100%;
              right: 50%;
              border: 5px solid
                ${(props) => props.theme.colors.palet.institutional4};
              border-left-color: transparent;
              border-bottom-color: transparent;

              opacity: 0;
              visibility: hidden;
              transform: translateY(10px);
              transition: 300ms;
            }
            &:hover {
              > img {
                filter: grayscale(0) !important;
              }
              &::after,
              &::before {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
              }
            }
            @media (max-width: 768px) {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50px);
              z-index: 1;

              > img {
                width: 20px;
                filter: grayscale(1) invert(1) brightness(0) invert(1) sepia(1);
              }
            }
          }
        }
      }
      tr:nth-child(1) {
        td.centered {
          label {
            &::before {
              top: calc(100% + 7px);
              z-index: 1;
            }
            &::after {
              top: 100%;
              border: 5px solid
                ${(props) => props.theme.colors.palet.institutional4};
              border-left-color: transparent;
              border-top-color: transparent;
            }
          }
        }
      }
    }
  }
`;

export const SerchDataToTableContainer = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    > div {
      &:nth-child(3),
      &:nth-child(4) {
        width: auto;
        flex: 1 1 0;
      }
    }
  }
`;

export const Table = styled(TableComponent)`
  /* Responsividade específica para o modal de dependente */
  @media (max-width: 826px) {
    .p-datatable-wrapper {
      overflow-x: auto !important;
      overflow-y: auto !important;
      max-height: 300px !important;

      table {
        min-width: 600px;

        th,
        td {
          min-width: 100px !important;
          padding: 8px 6px !important;
          font-size: 0.85rem !important;
          white-space: nowrap;
        }

        th:first-child,
        td:first-child {
          min-width: 40px !important;
          width: 40px !important;
        }

        /* Ajustar colunas específicas */
        th[data-field='holderId'],
        td[data-field='holderId'],
        th[data-field='cardId'],
        td[data-field='cardId'],
        th[data-field='beneficiaryName'],
        td[data-field='beneficiaryName'],
        th[data-field='status'],
        td[data-field='status'] {
          min-width: 120px !important;
        }
      }
    }

    .p-datatable-scrollable-header,
    .p-datatable-scrollable-body {
      scrollbar-width: thin;
      scrollbar-color: #ccc #f1f1f1;

      &::-webkit-scrollbar {
        height: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;

        &:hover {
          background: #999;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .p-datatable-wrapper {
      max-height: 250px !important;

      table {
        min-width: 500px;

        th,
        td {
          min-width: 80px !important;
          padding: 6px 4px !important;
          font-size: 0.8rem !important;
        }

        th[data-field='holderId'],
        td[data-field='holderId'],
        th[data-field='cardId'],
        td[data-field='cardId'],
        th[data-field='beneficiaryName'],
        td[data-field='beneficiaryName'],
        th[data-field='status'],
        td[data-field='status'] {
          min-width: 100px !important;
        }
      }
    }
  }

  @media (max-height: 814px) {
    .p-datatable-wrapper {
      max-height: 280px !important;
    }
  }

  @media (max-width: 826px) and (max-height: 814px) {
    .p-datatable-wrapper {
      max-height: 200px !important;
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  column-gap: 8px;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 826px) {
    flex-direction: column;
    gap: 0.8rem;
    padding: 1rem 0;

    button {
      width: 100% !important;
      padding: 12px 16px;
      font-size: 0.9rem;
      margin: 0 !important;

      &.marginRight {
        margin-right: 0 !important;
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    row-gap: 12px;
    padding: 0.8rem 0;

    button {
      width: 100% !important;
      padding: 14px 16px;
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    gap: 0.6rem;

    button {
      padding: 12px 14px !important;
      font-size: 0.9rem !important;
    }
  }

  > button.marginRight {
    margin-right: auto;

    @media (max-width: 826px) {
      margin-right: 0;
    }
  }
`;

export const ModalFormWrapper = styled(FormWrapper)`
  display: flex;
  flex-wrap: wrap;

  button {
    & + button {
      margin-left: auto;
    }
  }

  .form-group-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem 0;
    background-color: #fff;
  }

  .form-group {
    display: flex;
    gap: 1rem;
    align-items: flex-end;

    > div {
      flex: 1;
    }

    button {
      flex: 0 0 auto;
      min-width: 140px; /* Aumentado para acomodar o texto */
      padding: 12px 16px;
      white-space: nowrap; /* Evita quebra de linha */
    }
  }

  .responsive-buttons {
    display: none;
  }

  @media (max-width: 826px) {
    padding: 15px;

    .form-group-content {
      gap: 0.8rem !important;

      /* Primeiro grupo: Status e Carteirinha SEM botão */
      .form-group:first-child {
        flex-direction: column;
        gap: 0.8rem;

        > div {
          width: 100% !important;
          flex: none !important;
        }

        button {
          display: none !important;
        }
      }

      .form-group:last-child {
        flex-direction: column;
        gap: 0.8rem;

        > div {
          width: 100% !important;
          flex: none !important;
        }

        button {
          display: none !important;
        }
      }
    }

    .responsive-buttons {
      display: flex !important;
      gap: 0.8rem;
      margin-top: 0.8rem;

      button {
        flex: 1;
        padding: 12px 16px;
        font-size: 0.9rem;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 10px;

    .form-group {
      button {
        font-size: 0.85rem !important;
        padding: 10px 12px !important;
      }
    }

    @media (max-width: 826px) {
      .form-group:last-child {
        flex-direction: column !important;

        button {
          width: 100% !important;
          margin-top: 0.5rem;
        }
      }
    }
  }
`;

export const ModalContainer = styled.div`
  h2 {
    font-family: 'Unimed-Sans-SemiBold';
  }

  display: flex;
  flex-direction: column;
  position: relative;
  width: 350px;

  @media (max-width: 768px) {
    width: 220px;
  }
`;

export const ModalPart = styled.div``;

export const FilesContainer = styled.div`
  max-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 24px 0;

  overflow-y: auto;
  button {
    font-family: 'Unimed-Sans-SemiBold';
    border: none;
    outline: none;
    background: transparent;
    color: ${(props) => props.theme.colors.text.primary};
    transition: 300ms;
    &:hover {
      color: ${(props) => props.theme.colors.text.black};
    }
  }
`;

export const ButtonContainerModal = styled.div`
  padding-top: 15px;
`;

export const ModalButton = styled(ButtonComponent)`
  margin-top: 10px;
`;

export const HolderContentStyled = styled.div`
  margin-top: -30px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 120px);
  overflow-y: auto;

  h3 {
    text-align: left;
    margin-bottom: 1rem;
    text-transform: uppercase;
    color: rgb(10, 95, 85);
    font-size: 1.2rem;
  }

  .form-change-holder {
    display: flex;
    flex-direction: column;
    box-shadow: none;

    .form-group-content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin: 1rem 0;
      background-color: #fff;
    }
    .form-group {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
    }
  }

  .select-beneficiary-parents {
    input {
      min-height: 50px !important;
    }
  }

  .table-container {
    .p-datatable-wrapper {
      max-height: 400px;
      overflow: auto;
    }
  }

  @media (max-width: 826px) {
    max-height: calc(100vh - 80px);
    margin-top: -20px;
    padding: 0 10px;

    h3 {
      font-size: 1rem;
      margin-bottom: 0.8rem;
      text-align: center;
    }

    .form-change-holder {
      .form-group-content {
        gap: 0.8rem;
        margin: 0.8rem 0;
      }

      .form-group {
        flex-direction: column;
        gap: 0.8rem;

        > div {
          width: 100% !important;
          min-width: unset !important;
        }

        button {
          width: 100%;
          padding: 12px;
          font-size: 0.9rem;
        }
      }
    }

    .table-container {
      margin-top: 1rem;

      .p-datatable-wrapper {
        max-height: 300px;
        overflow-x: auto;
        overflow-y: auto;

        table {
          min-width: 600px;

          th,
          td {
            min-width: 100px !important;
            white-space: nowrap;
            padding: 8px 6px !important;
            font-size: 0.85rem;
          }

          th {
            &:first-child {
              min-width: 40px !important;
            }
          }

          td {
            &:first-child {
              min-width: 40px !important;
            }
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding: 0 5px;

    h3 {
      font-size: 0.9rem;
    }

    .table-container {
      .p-datatable-wrapper {
        max-height: 250px;

        table {
          min-width: 500px;

          th,
          td {
            min-width: 80px !important;
            padding: 6px 4px !important;
            font-size: 0.8rem;
          }
        }
      }
    }
  }

  @media (max-height: 814px) {
    max-height: calc(100vh - 100px);

    .table-container {
      .p-datatable-wrapper {
        max-height: 280px;
      }
    }
  }

  @media (max-width: 826px) and (max-height: 814px) {
    max-height: calc(100vh - 60px);

    .table-container {
      .p-datatable-wrapper {
        max-height: 200px;
      }
    }
  }
`;
